import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import html2pdf from "html2pdf.js";
import _ from "lodash";
import { useHistory } from "react-router-dom";

const PDFDownload = props => {

    console.log("New Page props: ", props);

    let isProcessing = true;

    let history = useHistory();

    useEffect(() => {
        if(props.location.state.fileName && props.location.state.htmlContent){
            generateConsultNotePDF(props.location.state.fileName, props.location.state.htmlContent);
        }
    }, []);

  const generateConsultNotePDF = async (
    fileName, content
  ) => {
    let docH = 650;
    let docW = 900;
    
      html2pdf(content, {
        margin: 1,
        filename: fileName,
        image: { type: "jpg", quality: 1 },
        html2canvas: { letterRendering: false, docH, docW, scale: 2 },
        jsPDF: { unit: "mm", format: [docH, docW], orientation: "l" }
      }).then(pdf => {
        console.log("PDF generated: ", pdf);
        history.goBack();
      });
  };

  return (
    <Fragment>
        {isProcessing && <Loader />}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  consultNote: state.consultNote
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PDFDownload);
